import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
  id: "slick_svg__slick",
  horizAdvX: 512
}, /*#__PURE__*/React.createElement("fontFace", {
  fontFamily: "slick",
  unitsPerEm: 512,
  ascent: 480,
  descent: -32
}), /*#__PURE__*/React.createElement("glyph", {
  unicode: "\\u2192",
  d: "M241 113l130 130c4 4 6 8 6 13s-2 9-6 13L241 399c-3 3-7 5-12 5s-10-2-13-5l-29-30c-4-3-6-7-6-12s2-10 6-13l87-88-87-88c-4-3-6-8-6-13s2-9 6-12l29-30c3-3 8-5 13-5s9 2 12 5zm234 143c0-40-9-77-29-110-20-34-46-60-80-80-33-20-70-29-110-29s-77 9-110 29c-34 20-60 46-80 80-20 33-29 70-29 110s9 77 29 110c20 34 46 60 80 80 33 20 70 29 110 29s77-9 110-29c34-20 60-46 80-80 20-33 29-70 29-110z"
}), /*#__PURE__*/React.createElement("glyph", {
  unicode: "\\u2190",
  d: "M296 113l29 30c4 3 6 7 6 12s-2 10-6 13l-87 88 87 88c4 3 6 8 6 13s-2 9-6 12l-29 30c-3 3-8 5-13 5s-9-2-12-5L141 269c-4-4-6-8-6-13s2-9 6-13l130-130c3-3 7-5 12-5s10 2 13 5zm179 143c0-40-9-77-29-110-20-34-46-60-80-80-33-20-70-29-110-29s-77 9-110 29c-34 20-60 46-80 80-20 33-29 70-29 110s9 77 29 110c20 34 46 60 80 80 33 20 70 29 110 29s77-9 110-29c34-20 60-46 80-80 20-33 29-70 29-110z"
}), /*#__PURE__*/React.createElement("glyph", {
  unicode: "\\u2022",
  d: "M475 256c0-40-9-77-29-110-20-34-46-60-80-80-33-20-70-29-110-29s-77 9-110 29c-34 20-60 46-80 80-20 33-29 70-29 110s9 77 29 110c20 34 46 60 80 80 33 20 70 29 110 29s77-9 110-29c34-20 60-46 80-80 20-33 29-70 29-110z"
}), /*#__PURE__*/React.createElement("glyph", {
  unicode: "a",
  d: "M475 439V311c0-5-1-9-5-13s-8-5-13-5H329c-8 0-13 3-17 11-3 7-2 14 4 20l40 39c-28 26-62 39-100 39-20 0-39-4-57-11-18-8-33-18-46-32-14-13-24-28-32-46-7-18-11-37-11-57s4-39 11-57c8-18 18-33 32-46 13-14 28-24 46-32 18-7 37-11 57-11 23 0 44 5 64 15 20 9 38 23 51 42 2 1 4 3 7 3s5-1 7-3l39-39c2-2 3-3 3-6 0-2-1-4-2-6-21-25-46-45-76-59-29-14-60-20-93-20-30 0-58 5-85 17s-51 27-70 47c-20 19-35 43-47 70s-17 55-17 85 5 58 17 85 27 51 47 70c19 20 43 35 70 47s55 17 85 17c28 0 55-5 81-15 26-11 50-26 70-45l37 37c6 6 12 7 20 4 8-4 11-9 11-17z"
})));

function SvgSlick(props) {
  return /*#__PURE__*/React.createElement("svg", props, _ref);
}

export default SvgSlick;